import React from 'react'
import { FiEdit } from 'react-icons/fi'
import { AiOutlineFolderView, AiOutlineEye, AiOutlineDelete } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../application/utils/Routes';

function FormBlock({ formItem, deleteAction }) {

    const maxLength = 100;

    const navigate = useNavigate();

    if(formItem.description){
         formItem.description =  formItem.description.length > maxLength ? `${formItem.description.substring(0, maxLength)}...` : formItem.description;
    }
    const navigateToFormDetails = (id) => {
        navigate(ROUTES.FORMDETAIL.replace(":id", id));
    }

    const navigateToFormEdit = () => {
        navigate(ROUTES.ADDFORM, {
            state: {
                "form": formItem
            }
        });
    }

    const navigateToFormResponses = () => {
        navigate(ROUTES.RESPONSES, {
            state: {
                "formId": formItem._id
            }
        });
    }

    const actions = [
        {
            icon: <AiOutlineEye />,
            desc: "View Form"
        },
        {
            icon: <FiEdit />,
            desc: "Edit Form"
        },
        {
            icon: <AiOutlineFolderView />,
            desc: "View Responses"
        },
        {
            icon: <AiOutlineDelete />,
            desc: "Delete Form"
        },
    ];

    const handleActionOver = (e) => {
        e.target.querySelector('span')?.classList.remove("hidden");
    }
    const handleActionOut = (e) => {
        e.target.querySelector('span')?.classList.add("hidden");
    }

    const handleClick = (action, id) => {

        switch (action) {
            case "View Form":
                navigateToFormDetails(id);
                break;
            case "Edit Form":
                navigateToFormEdit();
                break;
            case "View Responses":
                navigateToFormResponses();
            case "Delete Form":
                deleteAction(formItem);
                break;
            default:
                break;
        }

    }

    return (
        <div className=" shadow-md rounded-lg flex flex-col overflow-hidden" >
            <div className="p-4 flex-1">
                <h2 className=" font-bold pb-5">{formItem.title}</h2>

                <p className=" text-clip leading-7">
                    {formItem.description}
                </p>
            </div>


            <div className=" bg-green-50 p-3 text-xl flex items-center gap-5">

                {actions.map(action => <div
                    key={Math.random()}
                    className="flex items-center cursor-pointer gap-2 hover:bg-white p-2 rounded-sm hover:flex-1 transition"
                    onClick={() => handleClick(action.desc, formItem.id)}
                    onMouseOver={handleActionOver}
                    onMouseOut={handleActionOut}>
                    {action.icon}
                    <span className="hidden text-xs" >
                        {action.desc}
                    </span>

                </div>)}
            </div>
        </div>
    )
}

export default FormBlock